import { notifications } from "@mantine/notifications";
import * as Sentry from "@sentry/react";
import { v4 as uuidv4 } from "uuid";
import type { FeedbackType } from "./MessageUtils";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
export const sendSMEFeedbackToApi = async (
    apiKey: string | undefined,
    responseId: string,
    feedbackType: FeedbackType,
    feedback: string,
): Promise<boolean> => {
    const transactionId = uuidv4();
    Sentry.withScope((scope) => {
        scope.setTag("transaction_id", transactionId);
    });
    const response = await fetch(`${BACKEND_URL}/v1/feedback/sme/upsert`, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "X-Transaction-ID": transactionId,
        },
        method: "POST",
        body: JSON.stringify({
            response_id: responseId,
            feedback_type: feedbackType,
            comments: feedback,
        }),
    });
    // Do the some handling for the response that was being done in the SSE event listeners
    const res = await response.json();
    if (response.status !== 200) {
        notifications.show({
            color: "red",
            title: "Sorry, Feedback failed to be sent!",
            message: res.detail ?? "Please try again later",
        });
        return false;
    }
    notifications.show({
        color: "green",
        title: "Feedback sent successfully!",
        message: "Thanks for sharing, we'll keep improving!",
    });
    return true;
};
